export default {
  body: {
    padding: 5,
  },
  icon: {
    color: 'grey',
    // float: 'left',
    // width: '3%',
    // paddingTop: '30px',
    // marginLeft: '2%',
    // fontSize: '15px',
  },
  newData: {
    flex: 1,
    flexDirection: 'row',
  },
  noDataRow: {
    color: 'lightgrey',
    textAlign: 'center',
  },
  noData: {
    fontSize: 150,
    color: 'lightgrey',
  },
  resourceInput: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    padding: 3,
  },
  resourceInputRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  addDetails: {
    margin: 5,
    padding: 5,
  },
  roleCol: {
    width: 140,
  },
  // actionCol: {
  //   width: 70,
  // },
  datePicker: {
    display: 'none',
  },
  title: {
    textAlign: 'center',
  },
  stageCol: {
    width: 45,
    paddingLeft: 0,
    paddingRight: 0,
  },
  resources: {
    position: 'relative',
    clear: 'both',
  },
  // select: { float: 'left', width: '25%', marginTop: '-10px' },
  // text: { float: 'left', width: '25%', marginTop: '14px', textAlign: 'center' },
  font: { fontSize: '20px', textAlign: 'center' },
  flatBtn: { textAlign: 'center', marginLeft: '15px' },
  clear: { clear: 'both' },
  header: { float: 'left', width: '12%', marginLeft: '3%', marginTop: '25px' },
  filterRow: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  selectedCount: {
    marginLeft: '2%',
  },
  vertAlign: {
    verticalAlign: 'middle',
  },
  stageIcon: {
    width: 28,
    height: 28,
  },
};



// WEBPACK FOOTER //
// ./src/components/AssignResourcesToTasks/styles.js